import {
   useContext,
   useEffect,
 } from 'react'
import { SiteContext } from '../../Global/SiteContext'

export function useHandleActiveVariant(selectedVariant) {
   const { setActiveVariant } = useContext(SiteContext)
   useEffect(() => {
      if(selectedVariant) {
         setActiveVariant(selectedVariant)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [JSON.stringify(selectedVariant)])
 }